import { StaffType } from 'types/staff'
import { useMemo } from 'react'
import isBefore from 'date-fns/isBefore'
import isAfter from 'date-fns/isAfter'

const useRoleState = (staff: StaffType): string => {
  if (!staff) return ''
  return useMemo(() => {
    if (staff.invitation_expired_at && isBefore(new Date(), staff.invitation_expired_at.toDate())) return '招待中'
    if (staff.invitation_expired_at && isAfter(new Date(), staff.invitation_expired_at.toDate())) return '招待期限切れ'
    const role = staff.roles[0]
    if (!role) return '権限なし'
    switch (role.role) {
      case 9:
        return '管理者'
      case 5:
        return 'ビューワー'
      default:
        return '権限なし'
    }
  }, [staff])
}

export default useRoleState
